import * as d3 from "d3";

export { jobProgessGraph };

class jobProgessGraph {
  async horizontalBarGraph(divs, datas, widthVal, heightVal, clrScale) {
    const data = datas;
    // const data = [
    //   {
    //     count: 177,
    //     name: "Others",
    //   },
    //   {
    //     count: 95,
    //     name: "Panelist",
    //   },
    //   {
    //     count: 49,
    //     name: "Vendor",
    //   },
    //   {
    //     count: 51,
    //     name: "selected",
    //   },
    // ];
    console.log("datasss", data);
    const margin = { top: 10, right: 50, bottom: 20, left: 50 };

    const updateGraph = () => {
      d3.select(divs).select("svg").remove();

      const containerWidth = document.querySelector(divs).clientWidth;
      //   const containerHeight = document.querySelector(divs).clientHeight;
      //   const containerWidth = 1000;
      const containerHeight = heightVal;
      const width = containerWidth - margin.left - margin.right;
      const height = containerHeight - margin.top - margin.bottom;

      const svg = d3
        .select(divs)
        .append("svg")
        .attr(
          "viewBox",
          `0 0 ${width + margin.left + margin.right} ${
            height + margin.top + margin.bottom
          }`
        )
        .attr("preserveAspectRatio", "xMidYMid meet")
        .style("width", "100%")
        .style("height", "100%");
      // .style("background-color", "red");

      let largest = Math.max(...data.map((o) => o.count));
      if (largest < 5) {
        largest = largest + 3;
      } else {
        if (largest % 5 !== 0) {
          largest = largest + (5 - (largest % 5));
        }
        if (largest % 10 !== 0) {
          largest = largest + (largest % 10);
        } else {
          largest = largest + 10;
        }
      }

      //   const gAxis = svg
      //     .append("g")
      //     .attr("transform", `translate(${margin.left},${margin.top})`);

      const x = d3
        .scaleLinear()
        .domain([0, largest])
        .range([0, width + margin.right / 2]);

      const y = d3
        .scaleBand()
        .domain(data.map((d) => d.name))
        .range([margin.top + margin.top / 2, height - margin.bottom / 1.5])
        .padding(0);

      //   const yScale_grid = d3
      //     .scaleLinear()
      //     .domain([0, 5])
      //     .range([height, 0])
      //     .nice();

      //   const yScale = d3
      //     .scaleLinear()
      //     .domain([0, largest])
      //     .range([-margin.top / 2, height + margin.top / 2]);

      //   const yGridLine = d3
      //     .axisLeft(yScale_grid)
      //     .scale(yScale)
      //     .tickSize(-width - margin.right / 2, 0, 0)
      //     .ticks(5)
      //     .tickFormat("");

      //   gAxis
      //     .append("g")
      //     .classed("gridLine", true)
      //     .style("color", "#F0F0F0")
      //     .attr("opacity", "0.7")
      //     .call(yGridLine);

      //   const gText = svg
      //     .append("g")
      //     .attr(
      //       "transform",
      //       "translate(" +
      //         (width + margin.left + margin.right) / 2 +
      //         "," +
      //         (height + margin.top + margin.top / 1.2) +
      //         ")"
      //     );

      //   gText
      //     .append("text")
      //     .attr("class", "y label")
      //     .attr("text-anchor", "end")
      //     .attr("y", 6)
      //     .attr("dy", ".75em")
      //     .text(xText)
      //     .style("color", "#888888")
      //     .attr("opacity", "0.8")
      //     .style("font-size", "10px")
      //     .style("font-weight", "500")
      //     .style("font-family", "Montserrat");

      //   let xScaleDomain2 = data.map((d) => d.count);

      const xScale = d3
        .scaleLinear()
        .domain([0, largest])
        .range([0, width + margin.right / 2])
        .nice();
      const xAxisTranslate = height + margin.top + margin.top / 2;

      const tick1 = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + margin.left + "," + xAxisTranslate + ")"
        )
        .attr("class", "x axis")
        .call(d3.axisBottom(xScale).ticks(8).tickSizeOuter(0).tickSizeInner(0));
      svg.selectAll(".domain").attr("stroke-width", 0);

      tick1
        .selectAll("text")
        .style("color", "#72738E")
        .style("font-size", "8px")
        .style("font-weight", "500")
        .style("font-family", "Lato");

      //   const xScale11 = d3
      //     .scaleLinear()
      //     .domain(
      //       largest <= 10
      //         ? [0, 5]
      //         : largest <= 15
      //         ? [0, 3]
      //         : largest <= 20
      //         ? [0, 4]
      //         : [0, 5]
      //     )
      //     .range([0, width + margin.right / 2])
      //     .nice();

      const xGridLine = d3
        .axisBottom(xScale)
        .scale(xScale)
        .tickSize(-height)
        // .ticks(largest <= 10 ? 5 : largest <= 15 ? 3 : largest <= 20 ? 4 : 5)
        .tickFormat("");

      svg
        .append("g")
        .classed("gridLine", true)
        .attr(
          "transform",
          "translate(" + margin.left + "," + xAxisTranslate + ")"
        )
        .style("color", "#F0F0F0")
        .attr("opacity", "0.7")
        .call(xGridLine);
      svg.selectAll(".domain").attr("stroke-width", 0);

      const gSvg = svg
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);

      gSvg.append("g").call(
        d3
          .axisLeft(y)
          .tickSize(0)
          .tickPadding(15)
          .tickFormat(function (i) {
            if (data[i] && data[i].name.length > 20) {
              return data[i].name.slice(0, 20) + "..";
            } else if (data[i]) {
              return data[i].name;
            }
          })
      );

      gSvg.select(".domain").attr("stroke-width", 0);

      let colorScale = d3
        .scaleOrdinal()
        .domain(data.map((d) => d.name))
        .range(clrScale);
      // .range(["#F5D06E", "#269C8A", "#1A4164"]);

      const bars = gSvg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("x", 0)
        .attr("y", (d) => y(d.name))
        .attr("width", (d) => x(d.count))
        .attr("height", function () {
          return y.bandwidth();
        })
        .attr("rx", 3)
        .attr("ry", 3)
        .attr("fill", function (d) {
          return colorScale(d.name);
        });

      bars.raise();

      const labels = gSvg
        .selectAll(".bar-label")
        .data(data)
        .enter()
        .append("text")
        .attr("class", "bar-label")
        .attr("x", (d) => x(d.count) + 5)
        // .attr("y", (d) => y(d.name) + y.bandwidth()/1.2 )
        .attr(
          "y",
          (d) =>
            y(d.name) +
            (heightVal <= 120 ? y.bandwidth() / 1.4 : y.bandwidth() / 2)
        )
        .text(function (d) {
          return d.openingsCount
            ? d.count + "(out of " + d.openingsCount + ")"
            : d.count;
        })
        .attr("font-family", "Montserrat")
        .attr("font-weight", "500")
        .attr("font-size", "10px")
        .attr("fill", function (d) {
          return colorScale(d.name);
        });

      labels.raise();
    };

    // Initial render
    updateGraph();

    // Re-render on window resize
    window.addEventListener("resize", updateGraph);
  }
}
